import Vue from "vue";
import vuei18n from "vue-i18n"; //引入vue-i18n插件
import zh from "./zh"; //导入zh.js中文语言包
import en from "./en"; //导入en.js英文语言包
import vi from "./vi"; //导入vi.js越南文语言包
Vue.use(vuei18n);
const messages = {
  en: {
    ...en, //使用ES6扩展运算符解构en
  },
  zh: {
    ...zh,
  },
  vi: {
    ...vi,
  }
};
const i18n = new vuei18n({
  locale: localStorage.getItem("lang"),
  messages,
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js